export default __webpack_public_path__ + "static/media/me2.8182cc92.JPG";